export default __webpack_public_path__ + "static/media/logo.8d421b70.png";